import { useState } from 'react';
import { getApiErrorMessage } from '../../../services/api';
import { useAuth } from '../../../hooks/useAuth';
import { getSite, saveSite, type SiteContent } from '../../../utils/site';

/** One Appearance panel's unsaved copy of the site content. */
export function useSiteDraft() {
  const { can } = useAuth();
  const canEdit = can('System Settings', 'Edit');
  const [draft, setDraft] = useState<SiteContent>(getSite);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);
  const set = <K extends keyof SiteContent>(k: K, v: SiteContent[K]) => {
    setSaved(false);
    setDraft((cur) => ({ ...cur, [k]: v }));
  };
  const dirty = JSON.stringify(draft) !== JSON.stringify(getSite());
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      setDraft(await saveSite(draft));
      setSaved(true);
    } catch (err) {
      setError(getApiErrorMessage(err, 'Could not save. Please try again.'));
    } finally {
      setSaving(false);
    }
  };
  return { draft, set, setDraft, save, saving, error, saved, dirty, canEdit };
}
